import { useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
// import Sidebar from '../../components/Sidebar';

function BMICalculation() {
  const location = useLocation();
  const { selectedDate } = location.state || {};
  const language = localStorage.getItem("language");
  const udiseNumber = localStorage.getItem("udiseNumber");
  
  const [schoolData, setSchoolData] = useState(null);
  const [showModal, setShowModal] = useState(true);
  const [classValue, setClassValue] = useState('');
  const [divisionValue, setDivisionValue] = useState('');
  const [studentData, setStudentData] = useState([]);
  const [classes, setClasses] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [heightWeight, setHeightWeight] = useState({});
  const [selectedMonth, setSelectedMonth] = useState("June"); // Default month


  
    const openIndexedDB = () => {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version
  
        request.onerror = (event) => {
          console.error("IndexedDB error:", event.target.error);
          reject("Error opening IndexedDB");
        };
  
        request.onsuccess = (event) => {
          resolve(event.target.result);
        };
  
        request.onupgradeneeded = (event) => {
          const db = event.target.result;
          if (!db.objectStoreNames.contains('studentData')) {
            db.createObjectStore('studentData', { keyPath: 'id' });
          }
        };
      });
    };
  const fetchSchoolData = async () => {
    if (udiseNumber) {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['schoolData'], 'readonly');
        const objectStore = transaction.objectStore('schoolData');
        const request = objectStore.get(udiseNumber);

        request.onsuccess = (event) => {
          const data = event.target.result;
          if (data) {
            setSchoolData(data);
          }
        };

        request.onerror = (event) => {
          console.error("Error fetching school data:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching school data:', error);
      }
    }
  };

  useEffect(() => {
    fetchSchoolData ();
}, [udiseNumber]);

  useEffect(() => {
    fetchStudentData(); // Fetch student data on component mount
  }, [selectedDate]);

   
  const [selectedYear, setSelectedYear] = useState('')

    useEffect(() => {
    const fetchDefaultYear = async () => {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['defaultSettings'], 'readonly');
        const objectStore = transaction.objectStore('defaultSettings');
        const request = objectStore.get('defaultSettings');
    
        request.onsuccess = (event) => {
          const defaultSetting = event.target.result;
          
          if (defaultSetting) {
            const year = defaultSetting.defaultYear;
            setSelectedYear(year); // Set the default year
           
          } else {
            console.warn("No default settings found for the key 'defaultSettings'.");
          }
        };
        request.onerror = (event) => {
          console.error("Error fetching default settings:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching default year:', error);
      }
    };
    fetchDefaultYear();
  }, [udiseNumber]);



 const fetchStudentData = async () => {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['studentData'], 'readonly');
        const objectStore = transaction.objectStore('studentData');
        const allRecords = objectStore.getAll();
        allRecords.onsuccess = (event) => {
          const data = event.target.result;
          if (data) {
            const activeStudents = data.filter(student => student.isActive !== false);
            setStudentData(activeStudents);
            const classSet = new Set(activeStudents.map(student => student.currentClass).filter(Boolean));
            setClasses(Array.from(classSet));
            const heightWeightData = {};
            activeStudents.forEach(student => {
              heightWeightData[student.srNo] = {
                height: student.weightandHeight ? student.weightandHeight[selectedYear]?.[selectedMonth]?.height || '' : '',
                weight: student.weightandHeight ? student.weightandHeight[selectedYear]?.[selectedMonth]?.weight || '' : ''
              };
            });
            setHeightWeight(heightWeightData);
          }
        };
        allRecords.onerror = (event) => {
          console.error('Error fetching student data from IndexedDB:', event.target.error);
        };
      } catch (error) {
        console.error('Error fetching student data:', error);
      }
    };

  const filteredStudentData = studentData.filter(student => {
    const classMatch = classValue ? student.currentClass === classValue : true;
    const divisionMatch = divisionValue ? student.division === divisionValue : true;
    return classMatch && divisionMatch;
  });

  const handleClassChange = (e) => {
    const selectedClass = e.target.value;
    setClassValue(selectedClass);
    const divisionSet = new Set();
    studentData.forEach((student) => {
      if (student.currentClass === selectedClass && student.division) {
        divisionSet.add(student.division);
      }
    });
    setDivisions([...divisionSet]);
    setDivisionValue('');
  };

  const handleDivisionChange = (e) => {
    setDivisionValue(e.target.value);
  };

  const handlePrint = () => {
    const printContent = document.querySelector('.modal-content');

    if (printContent) {
      const cloneContent = printContent.cloneNode(true);
      const schoolName = cloneContent.querySelector('p');
      const otherDetails = cloneContent.querySelectorAll('p');

      otherDetails.forEach((p, index) => {
        if (index !== 0) { // Exclude the school name
            p.style.fontWeight = 'normal'; 
          }
        });
  
        if (schoolName) {
          schoolName.innerHTML = `<h5 style="font-size: 16px; margin-top: 10px;">${schoolData.schoolName}</h5>`;
        }
  
        const printWindow = window.open('', '', 'height=600,width=800');
        printWindow.document.write(`
          <html>
            <head>
              <title>Print Modal Content</title>
              <style>
                @page {
                  size: A4 portrait;
                  margin: 3mm;
                }
                body {
                  font-family: Arial, sans-serif;
                  margin: 0;
                }
                .modal-content {
                  margin: 20px;
                }
                thead {
                  background-color: #F0F0F0;
                }
                .tip-style {
                  text-align: center;
                  font-size: 12px;
                  margin-top: 20px;
                }
                #month-select {
                  margin-right: -30px;
                }
                .Monthname {
                  margin-left: 20px;
                }
                .Dailyrgposhan {
                  margin-top: 0;
                }
              </style>
            </head>
            <body>
              ${cloneContent.outerHTML}
            </body>
          </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      } else {
        console.error('Print content not found');
      }
    };
    const sortClasses = (classes, language) => {
      const classOrder = {
        "Class I": 1,
        "Class II": 2,
        "Class III": 3,
        "Class IV": 4,
        "Class V": 5,
        "Class VI": 6,
        "Class VII": 7,
        "Class VIII": 8,
        "Class IX": 9,
        "Class X": 10,
        "Class XI": 11,
        "Class XII": 12,
        "इयत्ता पहिली": 1,
        "इयत्ता दुसरी": 2,
        "इयत्ता तिसरी": 3,
        "इयत्ता चौथी": 4,
        "इयत्ता पाचवी": 5,
        "इयत्ता सहावी": 6,
        "इयत्ता सातवी": 7,
        "इयत्ता आठवी": 8,
        "इयत्ता नववी": 9,
        "इयत्ता दहावी": 10,
        "इयत्ता अकरावी": 11,
        "इयत्ता बारावी": 12,
      };
    
      return classes.sort((a, b) => classOrder[a] - classOrder[b]);
    };
    return (
      <div> 
        {/* <Sidebar /> */}
        <div className='main-content-of-page'>

        <div style={{width:'20%', zIndex:'10000', position:'relative', marginTop:'0', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)', borderRadius:'7px'}}>
          
            <select value={classValue} onChange={handleClassChange}  style={{  fontSize: '14px' }}>
              <option value="" >{language === "English" ? "Select Class" : "वर्ग निवडा"}</option>
              {sortClasses(classes.filter(cls => cls.trim() !== ""), language).map((cls, index) => (
                <option key={index} value={cls}>
                  {cls}
                </option>
              ))} 
            </select>
          </div>


          {showModal && (
            <div style={{
              position: 'fixed',
              top: '0',
              right: '0',
              width: '88%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: '1000',
              marginTop: '25px'
            }}>
              <div style={{
                backgroundColor: '#fff',
                padding: '30px',
                borderRadius: '10px',
                width: '850px',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.9)',
                maxHeight: '90%',
                overflowY: 'auto',
                position: 'relative',
              }}>
                <div className="modal-content">
                  <table style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    marginBottom: '30px',
                    fontFamily: 'Arial, sans-serif',
                    border: '1px solid black',
                    borderRadius: '10px',
                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                  }}>
                    <thead>
                      {schoolData && (
                        <tr>
                          <th colSpan="14" style={{
                            color: 'black',
                            padding: '5px',
                            borderRadius: '10px 10px 0 0',
                            textAlign: 'center',
                            lineHeight: '0.4',
                            borderBottom: '1px solid black',
                            borderLeft: '1px solid black',
                            borderRight: '1px solid black',
                            borderTop: '1px solid black',
                            fontSize: '13px',
                            position: 'relative' 
                          }}>
                            <p><strong><h6>{schoolData.schoolName}</h6></strong></p>
                            <p>{schoolData.sansthaName}</p>
                            <p>{language === "English" ? "Taluka:" : "तालुका:"} {schoolData.taluka}, {language === "English" ? "Jilha:" : "जिल्हा:"} {schoolData.jilha}</p>
                            <p style={{fontSize:'18px'}}>{language === "English" ? "School Nutrition Scheme" : "शालेय पोषण आहार योजना"}</p>
                            <p className='Dailyrgposhan' style={{ display: 'inline-block', backgroundColor: '#252729', color: 'white', padding: '10px', borderRadius: '5px', fontSize: '14px' }}>
    {language === "English" ? 
        `Students Weight and Height - Quarterly Report` : 
        `विद्यार्थ्यांचे वजन आणि उंची - त्रैमासिक अहवाल`}
    {classValue && ` (${classValue})`} {/* Show class in parentheses if classValue is not empty */}
</p>
                        </th>
                      </tr>
                    )}
                    <tr style={{ color: 'black' }}>
                      <th rowSpan={2} style={{ borderLeft: '1px solid black', width: '100px', ...thstyle, padding: 'auto 0px' }}>{language === "English" ? "Sr. No" : "क्रमांक"}</th>
                      <th rowSpan={2} style={thstyle}>{language === "English" ? "Students Name" : "विद्यार्थ्यांचे नाव"}</th>
                      <th colSpan={3} style={thstyle}>{language === "English" ? "June" : "जून"}</th>
                      <th colSpan={3} style={thstyle}>{language === "English" ? "September" : "सप्टेंबर"}</th>
                      <th colSpan={3} style={thstyle}>{language === "English" ? "December" : "डिसेंबर"}</th>
                      <th colSpan={3} style={thstyle}>{language === "English" ? "March" : "मार्च"}</th>
                    </tr>
                    <tr>
                      <th style={thstyle}> {language === "English" ? "Weight" : "वजन"} </th>
                      <th style={thstyle}>{language === "English" ? "Height" : "उंची"}</th>
                      <th style={thstyle}>BMI</th>
                      <th style={thstyle}>{language === "English" ? "Weight" : "वजन"}</th>
                      <th style={thstyle}>{language === "English" ? "Height" : "उंची"}</th>
                      <th style={thstyle}>BMI</th>
                      <th style={thstyle}>{language === "English" ? "Weight" : "वजन"}</th>
                      <th style={thstyle}>{language === "English" ? "Height" : "उंची"}</th>
                      <th style={thstyle}>BMI</th>
                      <th style={thstyle}>{language === "English" ? "Weight" : "वजन"}</th>
                      <th style={thstyle}>{language === "English" ? "Height" : "उंची"}</th>
                      <th style={thstyle}>BMI</th>
                    </tr>
                  </thead>

                  <tbody>
  {filteredStudentData.map((student, index) => (
    <tr key={student.srNo}>
      <td style={{ ...thstylebody, borderLeft: '1px solid black', padding: '15px 0' }}>{index + 1}</td>
      <td style={thstylebody}>{student.stdName} {student.stdFather} {student.stdSurname}</td>
      
      {/* June */}
      <td style={thstylebody}>{student.weightandHeight?.[selectedYear]?.June?.weight || ''}</td>
      <td style={thstylebody}>{student.weightandHeight?.[selectedYear]?.June?.height || ''}</td>
      <td style={thstylebody}>{calculateBMI(student.weightandHeight?.[selectedYear]?.June?.weight, student.weightandHeight?.[selectedYear]?.June?.height)}</td>

      {/* September */}
      <td style={thstylebody}>{student.weightandHeight?.[selectedYear]?.September?.weight || ''}</td>
      <td style={thstylebody}>{student.weightandHeight?.[selectedYear]?.September?.height || ''}</td>
      <td style={thstylebody}>{calculateBMI(student.weightandHeight?.[selectedYear]?.September?.weight, student.weightandHeight?.[selectedYear]?.September?.height)}</td>

      {/* December */}
      <td style={thstylebody}>{student.weightandHeight?.[selectedYear]?.December?.weight || ''}</td>
      <td style={thstylebody}>{student.weightandHeight?.[selectedYear]?.December?.height || ''}</td>
      <td style={thstylebody}>{calculateBMI(student.weightandHeight?.[selectedYear]?.December?.weight, student.weightandHeight?.[selectedYear]?.December?.height)}</td>

      {/* March */}
      <td style={thstylebody}>{student.weightandHeight?.[selectedYear]?.March?.weight || ''}</td>
      <td style={thstylebody}>{student.weightandHeight?.[selectedYear]?.March?.height || ''}</td>
      <td style={thstylebody}>{calculateBMI(student.weightandHeight?.[selectedYear]?.March?.weight, student.weightandHeight?.[selectedYear]?.March?.height)}</td>
    </tr>
  ))}
</tbody>

                </table>

                <div className='text-center mt-3 Certificate-dailyposhan' style={{ marginTop: 'auto' }}>
  <div className='signature-section' style={{ display: 'flex', justifyContent: 'space-between', margin: '0 auto', padding: '0 20px', fontSize: '13px', width: '70%', alignItems: 'center' }}>
    <div className='principal-signature' style={{ textAlign: 'left' }}>
      <p className='president-signature' style={{ textAlign: 'center', marginBottom: '0' }}>
      </p>
      <p className='schmgnt'></p>
    </div>

    <div className='principal-signature' style={{ textAlign: 'right' }}>
      <p className='president-signature' style={{ textAlign: 'center', marginBottom: '0' }}>
        {language === "English" ? "Class Teachers Signature " : "वर्गशिक्षकाची सही "}
      </p>
      <p className='schmgnt'>{language === "English" ? "Class Teachers Name" : "वर्गशिक्षकाचे नाव"}</p>
    </div>
  </div>

  <p className='tip-style' style={{ fontSize: '12px', marginTop: '20px' }}>
    {language === "English" ? "Note: Grievance Redressal Center Toll Free Number 18002339988" : "टीप: तक्रार निवारण केंद्र टोल फ्री क्रमांक १८००२३३९९८८"}
  </p>
</div>
              </div>

              <div style={{ textAlign: 'right', marginTop: '20px' }}>
                <button onClick={handlePrint} style={{
                  padding: '12px 20px',
                  backgroundColor: '#007BFF',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                  transition: 'background-color 0.2s ease',
                  marginRight: '10px'
                }}>
                  Print
                </button>

              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default BMICalculation;

// Helper function to calculate BMI
const calculateBMI = (weight, height) => {
  if (weight && height) {
    const heightInMeters = height / 100; // Convert height to meters
    return (weight / (heightInMeters * heightInMeters)).toFixed(2); // BMI formula
  }
  return '';
}

// Style objects
const thstyle = {
  fontSize: '14px',
  padding: '0px',
  fontWeight: '600',
  borderBottom: '1px solid black',
  textAlign: 'center',
  borderRight: '1px solid black',
  width: '60px', color:'black'
}

const thstylebody = {
  fontSize: '12px',
  padding: '7px',
  borderBottom: '1px solid black',
  textAlign: 'center',
  color: 'black',
  borderRight: '1px solid black',
}